var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:bell-notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.1992 6.10157C21.1992 8.03157 19.6292 9.60157 17.6992 9.60157C15.7692 9.60157 14.1992 8.03157 14.1992 6.10157C14.1992 4.17157 15.7692 2.60157 17.6992 2.60157C19.6292 2.60157 21.1992 4.17157 21.1992 6.10157ZM19.1992 11.3916C18.6992 11.5216 18.1992 11.6016 17.6992 11.6016C16.2413 11.5989 14.8439 11.0186 13.8131 9.98773C12.7822 8.95686 12.2019 7.55945 12.1992 6.10157C12.1992 4.63157 12.7792 3.30157 13.6992 2.31157C13.5177 2.08911 13.2889 1.90994 13.0294 1.78711C12.7699 1.66429 12.4863 1.6009 12.1992 1.60157C11.0992 1.60157 10.1992 2.50157 10.1992 3.60157V3.89157C7.22922 4.77157 5.19922 7.50157 5.19922 10.6016V16.6016L3.19922 18.6016V19.6016H21.1992V18.6016L19.1992 16.6016V11.3916ZM12.1992 22.6016C13.3092 22.6016 14.1992 21.7116 14.1992 20.6016H10.1992C10.1992 21.132 10.4099 21.6407 10.785 22.0158C11.1601 22.3909 11.6688 22.6016 12.1992 22.6016Z",
    fill: "#6A5E80"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellNotification);
export default __webpack_public_path__ + "static/media/bell-notification.39be6f4f097a430fff52bbc58fe09f6b.svg";
export { ForwardRef as ReactComponent };